import { Alarm } from "./alarm";

export class AlarmRow {
  private selected: boolean;
  private isOrphanedAlarmNode: boolean;
  private alarm: Alarm;
  observers: Set<() => void>;

  constructor(selected: boolean, alarm: Alarm, isOrphanedAlarmNode: boolean) {
    this.observers = new Set();

    this.selected = selected;
    this.alarm = alarm;
    this.isOrphanedAlarmNode = isOrphanedAlarmNode;
  }

  getSelected() {
    return this.selected;
  }

  getAlarm() {
    return this.alarm;
  }

  getIsOrphanedAlarmNode() {
    return this.isOrphanedAlarmNode;
  }

  setSelected(selected: boolean) {
    this.selected = selected;
    this.notifyObservers();
  }

  setAlarm(alarm: Alarm) {
    this.alarm = alarm;
  }

  setIsOrphanedAlarmNode(isOrphanedAlarmNode: boolean) {
    this.isOrphanedAlarmNode = isOrphanedAlarmNode;
  }

  addObserver(observer: () => void) {
    this.observers.add(observer);
  }

  removeObserver(observer: () => void) {
    this.observers.delete(observer);
  }

  notifyObservers() {
    this.observers.forEach((observer) => observer());
  }
}
